// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Body */
body {
  font-family: "Roboto", Arial, Verdana, Helvetica, sans-serif;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
}

* {
  box-sizing: border-box;
}

/* Layout */
.container-fluid {
  max-width: 100vw;
  min-height: 100vh;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}

.header {
  position: relative;
  padding: 1.5rem 3rem;
  background-color: #e8eaf6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.container {
  background-color: #fbfbfb;
  padding: 5rem 0;
}

.footer {
  position: relative;
  padding: 1.25rem 0;
  background-color: #e8eaf6;
  text-align: center;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  z-index: 1;
}

/* Typography */
.page-title {
  font-size: 2rem;
  margin: 0;
  padding: 0;
}

.card-title {
  font-size: 4rem;
  font-weight: bold;
}

.card-subtitle {
  font-size: 1.5rem;
  font-weight: bold;
}

.card-text {
  font-weight: normal;
  font-size: 1rem;
}

.fw-bold {
  font-weight: bold;
}

.text-muted {
  color: #6c757d;
}

.text-primary {
  color: #3b71ca;
}

.text-info {
  color: #54b4d3;
}

.text-warning {
  color: #e4a11b;
}

/* Spacing */
.me-1 {
  margin-right: 0.25rem;
}
.me-2 {
  margin-right: 0.5rem;
}
.me-3 {
  margin-right: 1rem;
}
.me-4 {
  margin-right: 1.5rem;
}
.me-5 {
  margin-right: 2rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 1rem;
}

.mt-auto {
  margin-top: auto;
}

.mb-auto {
  margin-bottom: auto;
}

.me-auto {
  margin-right: auto;
}

/* Form */
.form-wrapper {
  position: relative;
  width: max(500px, 30%);
  display: flex;
  flex-flow: column wrap;
  padding: 2rem 3rem;
  margin: 0 auto 3rem;
  background-color: #e8eaf6;
  border-radius: 1rem;
  gap: 2rem;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
  z-index: 2;
}

.form-row {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  padding: 1rem 0 0;
  margin-top: 0.7rem;
  width: 100%;
}

.form-row .error {
  display: inline-block;
  color: #d50000;
  font-size: 1rem;
  font-weight: normal;
  padding: 0;
}

.form-row .error.active {
  padding: 0.25rem 0.5rem;
}

.form-control {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid #9b9b9b;
  outline: 0;
  font-size: 1.3rem;
  color: #2962ff;
  padding: 0.5rem;
  background: transparent;
  transition: border-color 0.3s;
}

.form-control::placeholder {
  color: transparent;
}

.form-control:placeholder-shown ~ .form-label {
  font-size: 1.3rem;
  cursor: text;
  top: 1.5rem;
  left: 0.5rem;
}

.form-label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.3s;
  font-size: 1rem;
  color: #9b9b9b;
}

.form-control:valid {
  border-image: linear-gradient(to right, #11998e, #38ef7d);
}

.form-control:invalid {
  border-image: linear-gradient(to right, #d50000, #ff8a80);
}

.form-control.valid {
  border-width: 3px;
  border-image: linear-gradient(to right, #11998e, #38ef7d);
  border-image-slice: 1;
}

.form-control.invalid {
  border-width: 3px;
  border-image: linear-gradient(to right, #d50000, #ff8a80);
  border-image-slice: 1;
}

.form-control:focus {
  border-image: linear-gradient(to right, #2962ff, #82b1ff);
}

.form-control:focus,
.form-control:valid,
.form-control:invalid {
  padding-bottom: 0.5rem;
  font-weight: bold;
  border-width: 3px;
  border-image-slice: 1;
}

.form-control:placeholder-shown {
  border: 0;
  border-bottom: 2px solid #9b9b9b;
}

.form-control:focus:placeholder-shown {
  border-width: 3px;
  border-image: linear-gradient(to right, #2962ff, #82b1ff);
  border-image-slice: 1;
}

.form-control.valid:placeholder-shown {
  border-width: 3px;
  border-image: linear-gradient(to right, #11998e, #38ef7d);
  border-image-slice: 1;
}

.form-control.invalid:placeholder-shown {
  border-width: 3px;
  border-image: linear-gradient(to right, #d50000, #ff8a80);
  border-image-slice: 1;
}

/* reset input */
.form-control:required,
.form-control:invalid {
  box-shadow: none;
}

.btn-submit {
  display: inline-flex;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 auto;
  background-color: #2962ff;
  color: #fff;
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}

.btn-submit:hover,
.btn-submit:active {
  background-color: #0039cb;
  color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

/* Card */
.card {
  background-color: #e8eaf6;
  padding: 3rem 4rem;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  flex-direction: column;
  margin: 0 auto 2rem;
  text-align: center;
}

.card-body {
  display: flex;
  flex-flow: row wrap;
  flex-grow: 1;
  justify-content: space-evenly;
  gap: 4rem;
}

.card-row {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.card-col {
  display: flex;
  flex-direction: column;
}

.weather-main-icon {
  height: 5rem;
  width: auto;
}

.weather-icon {
  font-size: 3rem;
}

.card-item {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 200px;
  align-items: center;
  gap: 0.5rem;
}

.condition-text {
  max-width: 15rem;
  overflow-wrap: break-word;
}

/* Alert */
.alert {
  width: max(500px, 30%);
  display: flex;
  align-items: center;
  padding: 2rem;
  margin: 0 auto 3rem;
  background-color: #e8eaf6;
  border-radius: 1rem;
  gap: 1rem;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
  z-index: 2;
}

.alert-danger {
  border-left: 0.3rem solid #dc4c64;
  color: #dc4c64;
}

.alert-icon {
  font-size: 3rem;
}

.alert-text {
  font-size: 1.25rem;
  font-weight: bold;
}

/* Footer */
.footer-text {
  font-size: 1rem;
  font-weight: normal;
  color: #757575;
}

/* Animation */
.btn-submit {
  position: relative;
  overflow: hidden;
}

.btn-submit span {
  position: absolute;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  animation: ripple 1s;
  opacity: 0;
}

/* Add animation */
@keyframes ripple {
  from {
    opacity: 1;
    transform: scale(0);
  }

  to {
    opacity: 0;
    transform: scale(10);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,4DAA4D;EAC5D,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;;;;EASE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;EACjB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;;;EAGE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;;EAEE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,8DAA8D;AAChE;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF","sourcesContent":["/* Body */\r\nbody {\r\n  font-family: \"Roboto\", Arial, Verdana, Helvetica, sans-serif;\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul,\r\nli,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul {\r\n  list-style-type: none;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Layout */\r\n.container-fluid {\r\n  max-width: 100vw;\r\n  min-height: 100vh;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: grid;\r\n  grid-template-rows: auto 1fr auto;\r\n}\r\n\r\n.header {\r\n  position: relative;\r\n  padding: 1.5rem 3rem;\r\n  background-color: #e8eaf6;\r\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);\r\n  z-index: 1;\r\n}\r\n\r\n.container {\r\n  background-color: #fbfbfb;\r\n  padding: 5rem 0;\r\n}\r\n\r\n.footer {\r\n  position: relative;\r\n  padding: 1.25rem 0;\r\n  background-color: #e8eaf6;\r\n  text-align: center;\r\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);\r\n  z-index: 1;\r\n}\r\n\r\n/* Typography */\r\n.page-title {\r\n  font-size: 2rem;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.card-title {\r\n  font-size: 4rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.card-subtitle {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.card-text {\r\n  font-weight: normal;\r\n  font-size: 1rem;\r\n}\r\n\r\n.fw-bold {\r\n  font-weight: bold;\r\n}\r\n\r\n.text-muted {\r\n  color: #6c757d;\r\n}\r\n\r\n.text-primary {\r\n  color: #3b71ca;\r\n}\r\n\r\n.text-info {\r\n  color: #54b4d3;\r\n}\r\n\r\n.text-warning {\r\n  color: #e4a11b;\r\n}\r\n\r\n/* Spacing */\r\n.me-1 {\r\n  margin-right: 0.25rem;\r\n}\r\n.me-2 {\r\n  margin-right: 0.5rem;\r\n}\r\n.me-3 {\r\n  margin-right: 1rem;\r\n}\r\n.me-4 {\r\n  margin-right: 1.5rem;\r\n}\r\n.me-5 {\r\n  margin-right: 2rem;\r\n}\r\n\r\n.mb-1 {\r\n  margin-bottom: 0.25rem;\r\n}\r\n.mb-2 {\r\n  margin-bottom: 0.5rem;\r\n}\r\n.mb-3 {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.mt-auto {\r\n  margin-top: auto;\r\n}\r\n\r\n.mb-auto {\r\n  margin-bottom: auto;\r\n}\r\n\r\n.me-auto {\r\n  margin-right: auto;\r\n}\r\n\r\n/* Form */\r\n.form-wrapper {\r\n  position: relative;\r\n  width: max(500px, 30%);\r\n  display: flex;\r\n  flex-flow: column wrap;\r\n  padding: 2rem 3rem;\r\n  margin: 0 auto 3rem;\r\n  background-color: #e8eaf6;\r\n  border-radius: 1rem;\r\n  gap: 2rem;\r\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);\r\n  z-index: 2;\r\n}\r\n\r\n.form-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  position: relative;\r\n  padding: 1rem 0 0;\r\n  margin-top: 0.7rem;\r\n  width: 100%;\r\n}\r\n\r\n.form-row .error {\r\n  display: inline-block;\r\n  color: #d50000;\r\n  font-size: 1rem;\r\n  font-weight: normal;\r\n  padding: 0;\r\n}\r\n\r\n.form-row .error.active {\r\n  padding: 0.25rem 0.5rem;\r\n}\r\n\r\n.form-control {\r\n  font-family: inherit;\r\n  width: 100%;\r\n  border: 0;\r\n  border-bottom: 2px solid #9b9b9b;\r\n  outline: 0;\r\n  font-size: 1.3rem;\r\n  color: #2962ff;\r\n  padding: 0.5rem;\r\n  background: transparent;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.form-control::placeholder {\r\n  color: transparent;\r\n}\r\n\r\n.form-control:placeholder-shown ~ .form-label {\r\n  font-size: 1.3rem;\r\n  cursor: text;\r\n  top: 1.5rem;\r\n  left: 0.5rem;\r\n}\r\n\r\n.form-label {\r\n  position: absolute;\r\n  top: 0;\r\n  display: block;\r\n  transition: 0.3s;\r\n  font-size: 1rem;\r\n  color: #9b9b9b;\r\n}\r\n\r\n.form-control:valid {\r\n  border-image: linear-gradient(to right, #11998e, #38ef7d);\r\n}\r\n\r\n.form-control:invalid {\r\n  border-image: linear-gradient(to right, #d50000, #ff8a80);\r\n}\r\n\r\n.form-control.valid {\r\n  border-width: 3px;\r\n  border-image: linear-gradient(to right, #11998e, #38ef7d);\r\n  border-image-slice: 1;\r\n}\r\n\r\n.form-control.invalid {\r\n  border-width: 3px;\r\n  border-image: linear-gradient(to right, #d50000, #ff8a80);\r\n  border-image-slice: 1;\r\n}\r\n\r\n.form-control:focus {\r\n  border-image: linear-gradient(to right, #2962ff, #82b1ff);\r\n}\r\n\r\n.form-control:focus,\r\n.form-control:valid,\r\n.form-control:invalid {\r\n  padding-bottom: 0.5rem;\r\n  font-weight: bold;\r\n  border-width: 3px;\r\n  border-image-slice: 1;\r\n}\r\n\r\n.form-control:placeholder-shown {\r\n  border: 0;\r\n  border-bottom: 2px solid #9b9b9b;\r\n}\r\n\r\n.form-control:focus:placeholder-shown {\r\n  border-width: 3px;\r\n  border-image: linear-gradient(to right, #2962ff, #82b1ff);\r\n  border-image-slice: 1;\r\n}\r\n\r\n.form-control.valid:placeholder-shown {\r\n  border-width: 3px;\r\n  border-image: linear-gradient(to right, #11998e, #38ef7d);\r\n  border-image-slice: 1;\r\n}\r\n\r\n.form-control.invalid:placeholder-shown {\r\n  border-width: 3px;\r\n  border-image: linear-gradient(to right, #d50000, #ff8a80);\r\n  border-image-slice: 1;\r\n}\r\n\r\n/* reset input */\r\n.form-control:required,\r\n.form-control:invalid {\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-submit {\r\n  display: inline-flex;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  margin: 0 auto;\r\n  background-color: #2962ff;\r\n  color: #fff;\r\n  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.btn-submit:hover,\r\n.btn-submit:active {\r\n  background-color: #0039cb;\r\n  color: #fff;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Card */\r\n.card {\r\n  background-color: #e8eaf6;\r\n  padding: 3rem 4rem;\r\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.card-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 auto 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.card-body {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  flex-grow: 1;\r\n  justify-content: space-evenly;\r\n  gap: 4rem;\r\n}\r\n\r\n.card-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 100%;\r\n}\r\n\r\n.card-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.weather-main-icon {\r\n  height: 5rem;\r\n  width: auto;\r\n}\r\n\r\n.weather-icon {\r\n  font-size: 3rem;\r\n}\r\n\r\n.card-item {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 100%;\r\n  width: 200px;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.condition-text {\r\n  max-width: 15rem;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* Alert */\r\n.alert {\r\n  width: max(500px, 30%);\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 2rem;\r\n  margin: 0 auto 3rem;\r\n  background-color: #e8eaf6;\r\n  border-radius: 1rem;\r\n  gap: 1rem;\r\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);\r\n  z-index: 2;\r\n}\r\n\r\n.alert-danger {\r\n  border-left: 0.3rem solid #dc4c64;\r\n  color: #dc4c64;\r\n}\r\n\r\n.alert-icon {\r\n  font-size: 3rem;\r\n}\r\n\r\n.alert-text {\r\n  font-size: 1.25rem;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Footer */\r\n.footer-text {\r\n  font-size: 1rem;\r\n  font-weight: normal;\r\n  color: #757575;\r\n}\r\n\r\n/* Animation */\r\n.btn-submit {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.btn-submit span {\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  width: 100px;\r\n  height: 100px;\r\n  margin-top: -50px;\r\n  margin-left: -50px;\r\n  animation: ripple 1s;\r\n  opacity: 0;\r\n}\r\n\r\n/* Add animation */\r\n@keyframes ripple {\r\n  from {\r\n    opacity: 1;\r\n    transform: scale(0);\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n    transform: scale(10);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
